import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Input, Select } from "antd";
import RequestHandler from "util/RequestHandler";
import { SendOutlined } from "@ant-design/icons";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const TenantUserParameterPaymentSetSelectModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [form] = Form.useForm();
  const [paymentSelect, setPaymentSelect] = useState({
    data: [],
    loading: false,
  });
  const [defaultPaymentSetId, setDefaultPaymentSetId] = useState(null);

  useEffect(() => {
    if (props.paymentSetData) {
      setPaymentSelect({
        data: props.paymentSetData.data,
        loading: false,
      });
    }
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          setDefaultPaymentSetId(response.data.defaultPaymentSetId);
          if (response.data.defaultPaymentSetId) {
            const paymentSet = props?.paymentSetData?.data?.find(
              (x) => x.id === response.data.defaultPaymentSetId
            );
            form.setFieldsValue({
              defaultPaymentSetName: paymentSet?.name,
            });
          } else {
            form.setFieldsValue({
              defaultPaymentSetName: "Varsayılan",
            });
          }
        }
      }
    );
  }, []);

  const onFinish = (values) => {
    RequestHandler.post(
      `/TenantUserParameter/SetDefaultPaymentSetId`,
      {
        defaultPaymentSetId: values.defaultPaymentSetId ?? defaultPaymentSetId,
      },
      true
    ).then((response) => {
      if (response.success) {
        if (props.onSuccess) props.onSuccess();
      }
      setLoading(false);
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };
  return (
    <>
      <Form
        {...formItemLayout}
        form={form}
        name="posCollectionRefundModal"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="Varsayılan Ödeme Seti"
              name="defaultPaymentSetName"
            >
              <Input
                readOnly={true}
                disabled={true}
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item label="Ödeme Seti Seç" name="defaultPaymentSetId">
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
                loading={paymentSelect.loading}
                onChange={(value) => setDefaultPaymentSetId(value)}
                defaultValue={
                  paymentSelect.data.length > 0
                    ? paymentSelect.data[0].id
                    : undefined
                }
              >
                {paymentSelect.data.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Row justify="end" style={{ marginRight: "4%" }}>
              <Col>
                <Button
                  type="primary"
                  icon={<SendOutlined />}
                  htmlType="submit"
                  onClick={() => setLoading(true)}
                  loading={loading}
                >
                  Kaydet
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </>
  );
};
export default TenantUserParameterPaymentSetSelectModal;
